"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = negate;
// Returns a negated version of the passed-in predicate.
function negate(predicate) {
  return function () {
    return !predicate.apply(this, arguments);
  };
}